import React from 'react';
function Panel({ title, children, extra, className }) {
  return (
    <div className={`tech-panel ${className || ''}`}>
      <div className="panel-decoration top-left"></div>
      <div className="panel-decoration top-right"></div>
      <div className="panel-decoration bottom-left"></div>
      <div className="panel-decoration bottom-right"></div>
      
      <div className="panel-header">
        <div className="panel-title">
          <span className="title-bar"></span>
          <span>{title}</span>
        </div>
        {extra && <div className="panel-extra">{extra}</div>}
      </div>
      
      <div className="panel-body">
        {children}
      </div>
    </div>
  );
}

export default Panel;
